import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import BaseMixer from "../../BaseMixer";
import { WorkViewModule } from "@/store/modules/workView.module";
let WeekViewUserEntryComponent = /** @class */ (() => {
    let WeekViewUserEntryComponent = class WeekViewUserEntryComponent extends Mixins(BaseMixer) {
        created() { }
        get usersModeUsers() {
            return WorkViewModule.weekViewUserModeUsers;
        }
        get usersModeProjects() {
            return WorkViewModule.weekViewUsersModeProjects;
        }
    };
    WeekViewUserEntryComponent = __decorate([
        Component({
            name: "WeekViewUserEntryComponent",
            components: {},
        })
    ], WeekViewUserEntryComponent);
    return WeekViewUserEntryComponent;
})();
export default WeekViewUserEntryComponent;
